import { IAppState } from '../../../AppModulesWrapper';

export const selectIsMoneySourceWidgetVisibleInPromotionWrapper = (state: IAppState): boolean => {
  return state.servicePickerWidget.elementsVisibility.promotionWrapper.isMoneySourceWidgetVisible;
};
